// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"a532840d","418":"53e2a54e","425":"8114aa9c","747":"41c27f0f","926":"9d2e0d9b"}[chunkId] + ".chunk.js";
};